import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import CheckCircleIcon from "@atlaskit/icon/core/check-circle";
import ErrorIcon from "@atlaskit/icon/core/status-error";
import CheckCircleOutlineIcon from "@atlaskit/icon/core/status-success";
import { token } from "@atlaskit/tokens";

import { fontSize } from "@/components/signup/utils";
import { wacToken } from "@/libraries/design/foundations";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const InputIcon = ({ valid }: { valid: boolean | undefined }) => {
    const { formatMessage } = useIntl();

    const validMessage = formatMessage({
        id: "signupForm.accountCreation.validEmailIcon",
        defaultMessage: "Success"
    });

    const invalidMessage = formatMessage({
        id: "signupForm.accountCreation.invalidEmailIcon",
        defaultMessage: "Warning"
    });

    if (valid === undefined) {
        return null;
    }

    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    return valid ? (
        <div
            css={[
                iconValidCss,
                team26VisualUpdates && iconValidVisualUpdateCss,
                team26VisualUpdates && largerIconCss
            ]}
        >
            {team26VisualUpdates ? (
                <CheckCircleIcon label={validMessage} />
            ) : (
                <CheckCircleOutlineIcon label={validMessage} />
            )}
        </div>
    ) : (
        <div css={[iconInvalidCss, team26VisualUpdates && largerIconCss]}>
            <ErrorIcon label={invalidMessage} />
        </div>
    );
};

const iconWrapperStyle = {
    alignItems: "center",
    display: "flex",
    fill: wacToken("color.neutral.light0"),
    fontSize: fontSize.md,
    paddingInlineEnd: 8
};

const largerIconCss = css({
    paddingInlineEnd: 10,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    svg: {
        width: 20,
        height: 20
    }
});

const iconValidCss = css({
    ...iconWrapperStyle,
    color: token("color.border.success")
});

const iconValidVisualUpdateStyle = {
    color: wacToken("color.extended.lime600")
};

const iconValidVisualUpdateCss = css({
    ...iconValidVisualUpdateStyle
});

const iconInvalidCss = css({
    ...iconWrapperStyle,
    color: token("color.border.danger")
});
